import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Mail, Phone, Music2, MapPin } from "lucide-react";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6 }}
      className="section-padding section-navy border-t border-white/10"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <picture>
              <source srcSet="/images/logo-white.webp" type="image/webp" />
              <img src="/images/logo-white-sm.png" alt="N. Santiago Media — Marketing Agency in Port St. Lucie, Florida" width={144} height={56} className="h-14 w-auto mb-3" decoding="async" loading="lazy" />
            </picture>
            <p className="text-white/50 text-sm leading-relaxed max-w-md">
              N. Santiago Media helps dental clinics improve visibility, build patient trust, and convert more interest into scheduled appointments through strategy-driven marketing, content, reputation, and practice-level systems. We also support select local service-based businesses.
            </p>
            <div className="flex items-center gap-2 mt-4 text-white/40 text-xs">
              <MapPin className="w-3.5 h-3.5" />
              <span>Port St. Lucie, FL — Serving the Treasure Coast & Beyond</span>
            </div>
            <div className="flex gap-4 mt-5">
              <a href="https://www.instagram.com/n.santiagomedia" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-primary transition-colors" aria-label="N. Santiago Media on Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@nsantiagomedia" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-primary transition-colors" aria-label="N. Santiago Media on YouTube">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/nsantiagomedia" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-primary transition-colors" aria-label="N. Santiago Media on Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.tiktok.com/@n.santiagomedia" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-primary transition-colors" aria-label="N. Santiago Media on TikTok">
                <Music2 className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-primary mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-white/50">
              <li><Link to="/dental-marketing-agency-florida" className="hover:text-white transition-colors">Dental Marketing Agency in Florida</Link></li>
              <li><Link to="/dental-marketing-port-st-lucie" className="hover:text-white transition-colors">Dental Marketing — Port St. Lucie</Link></li>
              <li><Link to="/dental-marketing-stuart-fl" className="hover:text-white transition-colors">Dental Marketing — Stuart, FL</Link></li>
              <li><Link to="/google-business-profile-for-dentists" className="hover:text-white transition-colors">Google Business Profile for Dentists</Link></li>
              <li><Link to="/dental-video-marketing" className="hover:text-white transition-colors">Dental Video Marketing</Link></li>
              <li><Link to="/dental-patient-conversion-system" className="hover:text-white transition-colors">Dental Patient Conversion System</Link></li>
              <li><Link to="/seo-treasure-coast" className="hover:text-white transition-colors">Local SEO for Dentists</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Select Local Business Marketing</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-primary mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-white/50">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <a href="tel:7722022664" className="hover:text-white transition-colors">(772) 202-2664</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@nsantiagomedia.com" className="hover:text-white transition-colors">info@nsantiagomedia.com</a>
              </li>
            </ul>
            <p className="text-xs text-white/40 mt-6">
              Serving Port St. Lucie, Stuart, Jensen Beach, Palm City, Fort Pierce, Jupiter, West Palm Beach, and all of South Florida.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-xs text-white/40 space-y-3">
          <div className="flex justify-center gap-6">
            <Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link>
          </div>
          <p>© {new Date().getFullYear()} N. Santiago Media. All rights reserved. | Marketing Agency — Port St. Lucie, Treasure Coast, Florida</p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
